import React from 'react';
import {useFirebase} from "react-redux-firebase";
import {useNavigate} from "react-router-dom";
import {Menu} from "antd";
import {CalendarOutlined, SettingOutlined, SoundOutlined, UserOutlined, TagsOutlined, AudioOutlined} from '@ant-design/icons';
import {useSelector} from "react-redux";
import {useSpacePersistence} from "../hooks/useSpacePersistence";

export const UserMenu = () => {
    const navigate = useNavigate();
    const { clearLastSpaceId } = useSpacePersistence();

    const firebase = useFirebase();

    const currentSpace = useSelector((state) => {
        return state.spaces.current
    })

    const currentUser = useSelector((state) => {
        return state.users.current
    })

    const logout = () => {
        clearLastSpaceId();
        firebase.auth().signOut().then(() => {
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <Menu theme="dark" mode="inline" defaultSelectedKeys={['1']}>
            {currentSpace.data ? (
                <>
                    <Menu.Item onClick={() => navigate(`/spaces/${currentSpace.data.id}/recordings/`)} key="1"
                               icon={<SoundOutlined/>}>
                        Recordings
                    </Menu.Item>
                    <Menu.Item onClick={() => navigate(`/spaces/${currentSpace.data.id}/calendar/`)}
                               key="2" icon={<CalendarOutlined/>}>
                        Calendar
                    </Menu.Item>
                    <Menu.Item onClick={() => navigate(`/spaces/${currentSpace.data.id}/songs/`)} key="4"
                               icon={<AudioOutlined/>}>
                        Songs
                    </Menu.Item>
                    {currentUser && currentSpace.data.space_owner?.id === currentUser.id ? (
                        <>
                            <Menu.Item onClick={() => navigate(`/spaces/${currentSpace.data.id}/labels/`)} key="3"
                                       icon={<TagsOutlined/>}>
                                Labels
                            </Menu.Item>
                            <Menu.Item onClick={() => navigate(`/spaces/${currentSpace.data.id}/settings/`)} key="5"
                                       icon={<SettingOutlined/>}>
                                Settings
                            </Menu.Item>
                        </>
                    ) : null}
                </>) : null}

            <Menu.Item onClick={() => logout()} key="6" icon={<UserOutlined/>}>
                Logout
            </Menu.Item>
        </Menu>
    )
}
